import { render, staticRenderFns } from "./createNum.vue?vue&type=template&id=8aaf3332"
import script from "./createNum.vue?vue&type=script&lang=js"
export * from "./createNum.vue?vue&type=script&lang=js"
import style0 from "./createNum.vue?vue&type=style&index=0&id=8aaf3332&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports